module.exports = __webpack_public_path__ + "static/media/idlo.30284af5.png";